import React, { useState, useEffect, useCallback, useMemo } from 'react';
import 'firebase/storage';
import styled from 'styled-components';
import { Dialog } from '@reach/dialog';
import '@reach/dialog/styles.css';
import { useSnackbar } from 'notistack';
import { useBusinessCard } from './BusinessCard';
import YoutubeEmbed from './YoutubeEmbed';

const LightboxImage = ({ src }) => {
  return (
    <LBImageContainer>
      <LBImage src={src} />
    </LBImageContainer>
  );
};

const PromoVideo = ({ onDismiss, couponImageUri }) => {
  const instance = useBusinessCard();
  const {
    card: {promoVideo},
  } = instance;

  const embedId = useMemo(() => {
     return getYoutubeId(promoVideo);
  }, [promoVideo]);

  return (
    <>
      <StyledDialog isOpen={true} onDismissLightboxDescription={onDismiss}>
        <LighboxContainer>
          <LightboxHeader onClick={onDismiss}> חזרה לקטלוג </LightboxHeader>
          <YoutubeEmbed embedId={embedId} />
        </LighboxContainer>
      </StyledDialog>
    </>
  );

  function getYoutubeId(url){
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  }
};

const StyledDialog = styled(Dialog)`
  width: ${(p) => p.theme.dimensions.vw(90)}px;
  max-height: ${(p) => p.theme.dimensions.vh(90)}px;
  padding: 0.2rem;
  overflow-y: scroll;
`;
const LighboxContainer = styled.div`
  display: grid;
  grid-template-rows: 5rem 3fr fit-content auto;
  font-family: ${(p) => p.theme.font};
`;
const LightboxHeader = styled.span`
  cursor: pointer;
  grid-row: 1;
  padding: 0rem 1.75rem;
  height: 2rem;
`;
const LightboxDescription = styled.p`
  width: ${(p) => p.theme.dimensions.vw(75)}px;
  font-size: 30px;
  justify-self: center;
  margin: 0.5rem 0px;
`;

const LBImageContainer = styled.div`
  align-self: center;
  justify-self: center;
  border: 2px solid #111111;
  padding: 0rem 0.5rem 0.5rem 0.5rem;
  display: grid;
  width: 75vw;
  grid-template-rows: 3rem auto 1rem;
  position: relative;
`;

const LBImage = styled.img`
  width: 70vw;
  height: auto;
  grid-row: 2;
  justify-self: center;
  align-self: center;
  object-fit: contain;
`;



export default PromoVideo;
